"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsButton = exports.UsButtonColorsEnum = exports.UsButtonTypeEnum = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const UsButton_style_1 = require("./UsButton.style");
var UsButtonTypeEnum;
(function (UsButtonTypeEnum) {
    UsButtonTypeEnum["UNICO_BACKGROUND"] = "unicoBackground";
    UsButtonTypeEnum["BORDER_BOTTOM"] = "borderBottom";
    UsButtonTypeEnum["FLAT"] = "flat";
    UsButtonTypeEnum["TEXT_UNDERLINE"] = "text-underline";
    UsButtonTypeEnum["TEXT_NO_UNDERLINE"] = "text-no-underline";
    UsButtonTypeEnum["LIGHT_BLUE"] = "lightBlue";
})(UsButtonTypeEnum = exports.UsButtonTypeEnum || (exports.UsButtonTypeEnum = {}));
var UsButtonColorsEnum;
(function (UsButtonColorsEnum) {
    UsButtonColorsEnum["ROSSO"] = "rosso";
    UsButtonColorsEnum["ROSSO_DISABLED_GREY"] = "rosso-disabled-grey";
    UsButtonColorsEnum["AZZURRO_AR"] = "azzurro-ar";
    UsButtonColorsEnum["AZZURRO_AR_CTA"] = "azzurro-ar-cta";
    UsButtonColorsEnum["BLU_UNIPOL"] = "blu-unipol";
})(UsButtonColorsEnum = exports.UsButtonColorsEnum || (exports.UsButtonColorsEnum = {}));
const UsButton = (props) => {
    const buttonStyle = (0, react_1.useMemo)(() => {
        let style = Object.assign({ width: props.width, "border-radius": props.radius, "font-size": props.fontsize }, props.style);
        if (props.padding) {
            style = Object.assign(Object.assign({}, props.style), { padding: props.padding });
        }
        return style;
    }, [props.padding, props.style, props.width, props.radius, props.fontsize]);
    return ((0, jsx_runtime_1.jsx)(UsButton_style_1.UsButtonContainer, Object.assign({ role: "button", type: props.type, className: `us-button ${props.versione} ${props.colore}`, disabled: props.disabled, onClick: props.onClick, style: buttonStyle }, { children: props.children })));
};
exports.UsButton = UsButton;
exports.UsButton.defaultProps = {
    disabled: false,
    versione: UsButtonTypeEnum.UNICO_BACKGROUND,
    colore: UsButtonColorsEnum.ROSSO,
    width: "100%",
    radius: "0px",
    padding: "",
    style: {},
    fontsize: "16px",
    type: "button"
};
